export const ExceptionTypes = {
  JS_EXCEPTION: 'js',
  GRAPHQL_EXCEPTION: 'graphql',
  HTTP_EXCEPTION: 'http',
  AUTH_EXCEPTION: 'auth'
};

export const CustomEventTypes = {
  REDIRECT_TO_PAGE_404: 'redirect_to_page_404',
  REDIRECT_TO_PAGE_403: 'redirect_to_page_403'
};
